import { Routes } from '@angular/router';

import { supplierAuthGuard, supplierLoginGuard } from './core/guards/supplier-auth.guard';
import { AppLayoutComponent } from './core/layout/shell/app-layout/app-layout.component';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [supplierLoginGuard],
    loadComponent: () => import('./features/auth/login/login').then((m) => m.SupplierLogin),
  },
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [supplierAuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'purchase-order-pending',
      },
      {
        path: 'purchase-order-pending',
        data: { tab: 'purchase-order-pending' },
        loadComponent: () => import('./features/home/home.page').then((m) => m.HomePage),
      },
      {
        path: 'purchase-order-received',
        data: { tab: 'purchase-order-received' },
        loadComponent: () => import('./features/home/home.page').then((m) => m.HomePage),
      },
      {
        path: 'invoices-reports',
        data: { tab: 'invoices-reports' },
        loadComponent: () => import('./features/home/home.page').then((m) => m.HomePage),
      },
      {
        path: 'completed-last-12-months',
        data: { tab: 'completed-last-12-months' },
        loadComponent: () => import('./features/home/home.page').then((m) => m.HomePage),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
